"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaxRankContainer = exports.RankContainer = exports.Ranking = exports.KeywordsContainer = exports.StyledKeyword = exports.StyledKeywordText = exports.StyledKeywordContainer = exports.BPEntities = exports.ReferrerPlaceholderImage = exports.QuestionPlaceholderImage = exports.CampaignPlaceholderImage = exports.InvisibleUnitImage = exports.ContentPlaceholderImage = exports.EllipsisTitle = exports.NumUnitIcon = exports.StyledCellTextContainer = exports.CellTextBox = exports.StyledIcon = exports.StyledHeaderCell = exports.StyledHeaderContainer = exports.StyledCellQuestion = exports.KnotchBar = exports.StyledCellQuestionContainer = exports.StyledCellImage = exports.HeaderCell = exports.StyledCell = exports.TooltipIcon = exports.ToolTipBody = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _knotchincWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.styled-helpers");

var _numUnits = _interopRequireDefault(require("./assets/numUnits.svg"));

var _emptyContentCard = _interopRequireDefault(require("./assets/emptyContentCard.svg"));

var _invisible_unit = _interopRequireDefault(require("./assets/invisible_unit.svg"));

var _emptyCampaignCard = _interopRequireDefault(require("./assets/emptyCampaignCard.svg"));

var _emptyQuestionCard = _interopRequireDefault(require("./assets/emptyQuestionCard.svg"));

var _emptyReferrerCard = _interopRequireDefault(require("./assets/emptyReferrerCard.svg"));

var _tooltip_info_icon = _interopRequireDefault(require("./assets/tooltip_info_icon.svg"));

var _tooltip_info_icon_pink = _interopRequireDefault(require("./assets/tooltip_info_icon_pink.svg"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n        background: ", ";\n        color: white;\n      "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  padding: 3px 8px 2px;\n  border-radius: 30px;\n  text-align: center;\n  margin-bottom: 2px;\n  display: inline-block;\n\n  ", "\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  color: #939AAB;\n  font-size: 10px;\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  color: #323848;\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n    white-space: normal;\n    line-height: 34px;\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    ", " {\n      margin: 0%;\n\n      &:nth-child(1) {\n        width: 40%;\n        background-color:#213E58;\n      }\n\n      &:nth-child(2) {\n        width: 25%;\n        background-color:#2B4F70;\n      }\n\n      &:nth-child(3) {\n        width: 15%;\n        background-color:#446D93;\n      }\n\n      &:nth-child(4) {\n        width: 10%;\n        background-color:#6994BB;\n      }\n\n      &:nth-child(5) {\n        width: 10%;\n        background-color:#B3CDE4;\n      }\n    }\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: left;\n  text-overflow: ellipsis;\n  width: 99%;\n  overflow: hidden;\n  white-space: nowrap;\n  height: 100%;\n  padding-left: 3px;\n\n  ", "\n\n  ", "\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  overflow: hidden;\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  max-width: 99%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 6px 10px;\n  border-radius: 20px;\n  position: relative;\n  line-height: 14px;\n  height: 27px;\n  font-size: 9px;\n  background-color: ", ";\n  transition: all 0.3s ease;\n  color: white;\n  margin: 0 2px;\n  text-align: center;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n\n  &,\n  & > a,\n  & > a:visited {\n    color: ", ";\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  background-image: url('", "');\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  background-image: url('", "');\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  background-image: url('", "');\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  background-image: url('", "');\n  background-position: center center;\n  background-size: 25%;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n  overflow: hidden;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  background-image: url('", "');\n  background-position: center center;\n  background-size: 25%;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n  overflow: hidden;\n  ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n\n  &, a {\n    color: ", ";\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  position: relative;\n  top: 2px;\n  height: 11px;\n  width: 9px;\n  background-repeat: no-repeat;\n  background-size: 9px 11px;\n  background-position: center center;\n  background-image: url(", ");\n  transition: all .3s ease;\n  margin-right: 8px;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  width: 95%;\n  margin: auto;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  text-align: left;\n  padding-left: 20px;\n  line-height: 1.4;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    width: 28px;\n    height: 28px;\n    vertical-align: middle;\n    background: #d4dae2 url(\"", "\");\n    position: relative;\n    margin-right: 10px;\n    background-size: cover;\n    background-position: center;\n    border-radius: 100%;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  transition: all .3s ease;\n  ", "\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 20%;\n  background: ", ";\n  height:", ";\n  margin-top:", ";\n  display: inline-block;\n  z-index: 1;\n  position: relative;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 100%;\n  width: 70px;\n  display: inline-block;\n  position: relative;\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n  overflow: hidden;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 70px;\n  position: absolute;\n  left: 0;\n  display: inline-block;\n  background-color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n\n      .tooltip-trigger-text  {\n        ", ":after {\n          color: ", ";\n        }\n      }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n\n    &:hover {\n      span {\n        color: ", ";\n      }\n\n      .tooltip-trigger-text  {\n        ", ":after {\n          color: ", ";\n        }\n      }\n    }\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: ", ";\n  font-size: 13px;\n  line-height: 16px;\n  color: #636A7D;\n  font-family: Brandon;\n  width: ", ";\n  letter-spacing: ", ";\n  text-align: center;\n  line-height: normal;\n  vertical-align: middle;\n  padding: 0 2px;\n  padding-left: 0;\n  position: relative;\n  text-transform: capitalize;\n\n  .tooltip-trigger-text {\n    position: absolute;\n    top: -2px;\n    right: -18px;\n\n    ", " {\n      background-size: 9px;\n    }\n  }\n\n  ", "\n\n  ", "\n\n  &:first-child {\n    text-align: left;\n    padding-left: 20px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline-block;\n  font-size: 13px;\n  font-family: Brandon;\n  text-align: center;\n  height: ", ";\n  width: ", ";\n  line-height: normal;\n  vertical-align: middle;\n  padding: ", ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: ", ";\n  text-transform: ", ";\n\n  &:first-child {\n    text-align: left;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    &:after {\n      content: '\u2193';\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    &:after {\n      content: '\u2191';\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  &:after {\n    content: '';\n    position: relative;\n    top: 1px;\n    left: 2px;\n    height: 10px;\n    line-height: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 20px;\n  width: 20px;\n  background: url(", ") center center no-repeat;\n  background-size: 9px;\n  position: relative;\n  top: -1px;\n  padding-left: 6px;\n\n  &:hover {\n    background-image: url(", ");\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  color: #858585;\n  box-shadow:  0px 5px 20px rgba(0, 0, 0, 0.1);\n  background: #FFFFFF;\n  font-size: 12px;\n  padding: 30px;\n  border-radius: 15px;\n  z-index: 2;\n  border-top-left-radius: 0;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ToolTipBody = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var style = _ref.style;
  return style;
});

exports.ToolTipBody = ToolTipBody;

var TooltipIcon = _styledComponents["default"].div(_templateObject2(), _tooltip_info_icon["default"], _tooltip_info_icon_pink["default"]);

exports.TooltipIcon = TooltipIcon;
var baseSortable = (0, _styledComponents.css)(_templateObject3());
var arrows = {
  asc: (0, _styledComponents.css)(_templateObject4()),
  desc: (0, _styledComponents.css)(_templateObject5())
};
var styledCellCapitalizedTypes = ['top_sentiment_type', 'overall'];

var StyledCell = _styledComponents["default"].div(_templateObject6(), function (_ref2) {
  var theme = _ref2.theme,
      sorted = _ref2.sorted;
  return sorted ? theme.colors.textGrey : '#323848';
}, function (_ref3) {
  var height = _ref3.height;
  return height ? "".concat(height) : 'auto';
}, function (_ref4) {
  var width = _ref4.width;
  return width ? "".concat(width * 100, "%") : 'auto';
}, function (_ref5) {
  var padding = _ref5.padding;
  return padding || '0';
}, function (_ref6) {
  var sorted = _ref6.sorted;
  return sorted ? 'bold' : 'auto';
}, function (_ref7) {
  var type = _ref7.type;
  return styledCellCapitalizedTypes.includes(type) ? 'capitalize' : 'initial';
});

exports.StyledCell = StyledCell;

var HeaderCell = _styledComponents["default"].div(_templateObject7(), function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.fontSizes[2], "px");
}, function (_ref9) {
  var width = _ref9.width;
  return width ? "".concat(width * 100, "%") : 'auto';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.letterSpacings.title;
}, TooltipIcon, function (_ref11) {
  var sortable = _ref11.sortable;
  return sortable && (0, _styledComponents.css)(_templateObject8(), function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.palette[7];
  }, TooltipIcon, function (_ref13) {
    var theme = _ref13.theme;
    return theme.colors.palette[7];
  });
}, function (_ref14) {
  var sorted = _ref14.sorted;
  return sorted && (0, _styledComponents.css)(_templateObject9(), function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.palette[7];
  }, TooltipIcon, function (_ref16) {
    var theme = _ref16.theme;
    return theme.colors.palette[7];
  });
});

exports.HeaderCell = HeaderCell;

var StyledCellImage = _styledComponents["default"].div(_templateObject10(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.palette[5];
});

exports.StyledCellImage = StyledCellImage;

var StyledCellQuestionContainer = _styledComponents["default"].div(_templateObject11(), function (_ref18) {
  var url = _ref18.url;
  return url ? "url(".concat(url, ")") : 'none';
});

exports.StyledCellQuestionContainer = StyledCellQuestionContainer;

var KnotchBar = _styledComponents["default"].div(_templateObject12(), function (_ref19) {
  var color = _ref19.color;
  return color;
}, function (_ref20) {
  var pctHeight = _ref20.pctHeight;
  return "".concat(pctHeight, "%");
}, function (_ref21) {
  var pctHeight = _ref21.pctHeight;
  return "".concat(100 - pctHeight, "%");
});

exports.KnotchBar = KnotchBar;

var StyledCellQuestion = function StyledCellQuestion(_ref22) {
  var children = _ref22.children;
  return /*#__PURE__*/_react["default"].createElement(StyledCellQuestionContainer, null, children, /*#__PURE__*/_react["default"].createElement(KnotchBar, {
    color: "#5ca7ce",
    pctHeight: 0
  }), /*#__PURE__*/_react["default"].createElement(KnotchBar, {
    color: "#93c5de",
    pctHeight: 0
  }), /*#__PURE__*/_react["default"].createElement(KnotchBar, {
    color: "#fff",
    pctHeight: 20
  }), /*#__PURE__*/_react["default"].createElement(KnotchBar, {
    color: "#fc5e6c",
    pctHeight: 40
  }), /*#__PURE__*/_react["default"].createElement(KnotchBar, {
    color: "#fc376c",
    pctHeight: 60
  }));
};

exports.StyledCellQuestion = StyledCellQuestion;

var StyledHeaderContainer = _styledComponents["default"].span(_templateObject13(), function (_ref23) {
  var sortable = _ref23.sortable;
  return sortable && baseSortable;
}, function (_ref24) {
  var sortOrder = _ref24.sortOrder;
  return sortOrder !== null && arrows[sortOrder];
});

exports.StyledHeaderContainer = StyledHeaderContainer;

var StyledHeaderCell = function StyledHeaderCell(props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderCell, props, /*#__PURE__*/_react["default"].createElement(StyledHeaderContainer, {
    sortable: props.sortable,
    sortOrder: props.sortOrder
  }, props.children));
};

exports.StyledHeaderCell = StyledHeaderCell;

var StyledIcon = _styledComponents["default"].div(_templateObject14(), function (_ref25) {
  var bg = _ref25.bg;
  return bg;
});

exports.StyledIcon = StyledIcon;

var CellTextContainer = _styledComponents["default"].div(_templateObject15(), _knotchincWebReactComponentsUtils.contentCentered, function (_ref26) {
  var offset = _ref26.offset;
  return (0, _knotchincWebReactComponentsUtils.absFull)(0, 0, 0, "".concat(typeof offset === 'number' ? offset : 70, "px"));
});

var CellTextBox = _styledComponents["default"].div(_templateObject16());

exports.CellTextBox = CellTextBox;

var StyledCellTextContainer = function StyledCellTextContainer(_ref27) {
  var children = _ref27.children,
      offset = _ref27.offset,
      withImage = _ref27.withImage;
  return /*#__PURE__*/_react["default"].createElement(CellTextContainer, {
    offset: withImage ? offset : 0
  }, /*#__PURE__*/_react["default"].createElement(CellTextBox, null, children));
};

exports.StyledCellTextContainer = StyledCellTextContainer;

var NumUnitIcon = _styledComponents["default"].div(_templateObject17(), _numUnits["default"]);

exports.NumUnitIcon = NumUnitIcon;

var EllipsisTitle = _styledComponents["default"].div(_templateObject18(), function (props) {
  return props.theme.colors.textGrey;
});

exports.EllipsisTitle = EllipsisTitle;

var ContentPlaceholderImage = _styledComponents["default"].div(_templateObject19(), _emptyContentCard["default"], (0, _knotchincWebReactComponentsUtils.absFull)());

exports.ContentPlaceholderImage = ContentPlaceholderImage;

var InvisibleUnitImage = _styledComponents["default"].div(_templateObject20(), _invisible_unit["default"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.palette[2];
});

exports.InvisibleUnitImage = InvisibleUnitImage;
var CampaignPlaceholderImage = (0, _styledComponents["default"])(ContentPlaceholderImage)(_templateObject21(), _emptyCampaignCard["default"]);
exports.CampaignPlaceholderImage = CampaignPlaceholderImage;
var QuestionPlaceholderImage = (0, _styledComponents["default"])(ContentPlaceholderImage)(_templateObject22(), _emptyQuestionCard["default"]);
exports.QuestionPlaceholderImage = QuestionPlaceholderImage;
var ReferrerPlaceholderImage = (0, _styledComponents["default"])(ContentPlaceholderImage)(_templateObject23(), _emptyReferrerCard["default"]);
exports.ReferrerPlaceholderImage = ReferrerPlaceholderImage;

var BPEntities = _styledComponents["default"].div(_templateObject24(), function (props) {
  return props.theme.colors.palette[7];
});

exports.BPEntities = BPEntities;

var StyledKeywordContainer = _styledComponents["default"].div(_templateObject25(), function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.palette[7];
});

exports.StyledKeywordContainer = StyledKeywordContainer;

var StyledKeywordText = _styledComponents["default"].div(_templateObject26(), function (_ref30) {
  var allowMultiline = _ref30.allowMultiline;
  return allowMultiline ? '100%' : '90%';
});

exports.StyledKeywordText = StyledKeywordText;

var StyledKeyword = function StyledKeyword(_ref31) {
  var allowMultiline = _ref31.allowMultiline,
      children = _ref31.children;
  return /*#__PURE__*/_react["default"].createElement(StyledKeywordContainer, null, /*#__PURE__*/_react["default"].createElement(StyledKeywordText, {
    allowMultiline: allowMultiline
  }, children));
};

exports.StyledKeyword = StyledKeyword;

var KeywordsContainer = _styledComponents["default"].div(_templateObject27(), _knotchincWebReactComponentsUtils.contentCentered, function (_ref32) {
  var stats = _ref32.stats;
  return stats && (0, _styledComponents.css)(_templateObject28(), StyledKeywordContainer);
}, function (_ref33) {
  var allowMultiline = _ref33.allowMultiline;
  return allowMultiline && (0, _styledComponents.css)(_templateObject29());
});

exports.KeywordsContainer = KeywordsContainer;

var Ranking = _styledComponents["default"].span(_templateObject30());

exports.Ranking = Ranking;

var RankContainer = _styledComponents["default"].div(_templateObject31());

exports.RankContainer = RankContainer;

var MaxRankContainer = _styledComponents["default"].div(_templateObject32(), function (_ref34) {
  var top = _ref34.top,
      bottom = _ref34.bottom;

  if (top || bottom) {
    var color = 'white';

    if (top) {
      color = '#F8377B';
    } else if (bottom) {
      color = '#2D8BFF';
    }

    return (0, _styledComponents.css)(_templateObject33(), color);
  }
});

exports.MaxRankContainer = MaxRankContainer;

//# sourceMappingURL=styled.js.map